module.exports = __webpack_public_path__ + "873a7e711ca608ef5867183255016fdc.pdf";